function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { variables } from '@domain-group/fe-brary';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import AllhomesListingPhotoCarousel from '@domain-group/fe-co-allhomes-listing-photo-carousel';
import { EventBoundary, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AllhomesKeyDetailsGraphQL } from '@domain-group/fe-co-allhomes-key-details';
import { AllhomesListingSummaryGraphQL } from '@domain-group/fe-co-allhomes-listing-summary';
import { AllhomesListingSuburbStatsGraphQL } from '@domain-group/fe-co-allhomes-listing-suburb-stats';
import { MobileEnquiryCTAGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import { AllhomesListingMapGraphQL } from '@domain-group/fe-co-allhomes-listing-map';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import StickyMobile from '@domain-group/fe-co-allhomes-sticky-footer';
import { PropertyHistoryGraphQL } from '@domain-group/fe-co-allhomes-property-history';
import { ListingViewsGraphQL } from '../components/listing-views';
import { ShareDetailsGraphQL, SharePreferencesGraphQL } from '../components/share-details';
import ListingAvailabilityGraphQL from '../components/availability/listing-availability-graphql';
import StickySidebox from '../components/sticky-sidebox';
import OnMarketSidebox from '../components/on-market-sidebox';
import ListingPhotoPreview from '../components/allhomes-listing-hero-photo-preview';
import { Inner, InnerLeft, InnerRight, Section, HeroImages, Clear, Bottom } from '../components/structure';
import FlagAsInappropriateLink from '../components/flag-as-inappropriate-link';
import AllhomesListingWhatsNearbyGraphQL from '../components/what-is-nearby/allhomes-listing-whats-nearby-graphql';
import { NbnCardGraphQL } from '../components/nbn-card';
import ListingDetailsCommonProps, { ListingDetailsDefaultValues } from '../props/common-props';
import { onMarketPropertyWrapper } from '../wrappers';
import useBackToSearch from '../utils/back-to-search';
import useSendPageView from '../analytics/use-send-page-view';
import * as sharedStyles from './on-market.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseOnMarketShareListingDetails = props => {
  var _property$agents, _property$listing, _property$listing$med;
  useSendPageView();
  var sidebarBottomRef = useRef();
  var enquiryFormStart = useRef();
  var property = props.property;
  var _props$media = props.media,
    mobile = _props$media.mobile,
    tablet = _props$media.tablet,
    desktop = _props$media.desktop;
  var backToSearch = useBackToSearch(props.referrer);
  var handleEmailClick = () => {
    if (props.shareListingEmailLink) {
      window.location = props.shareListingEmailLink;
    }
  };
  var hasAgents = ((_property$agents = property.agents) === null || _property$agents === void 0 ? void 0 : _property$agents.length) > 0;
  return ___EmotionJSX("div", null, mobile && hasAgents && ___EmotionJSX(StickyMobile, {
    limitRef: enquiryFormStart
  }, ___EmotionJSX(MobileEnquiryCTAGraphQL, {
    property: property,
    onEmailClick: handleEmailClick
  })), mobile && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(HeroImages, null, ___EmotionJSX(ListingPhotoPreview, props), props.carouselOpen && !isEmpty((_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$med = _property$listing.media) === null || _property$listing$med === void 0 ? void 0 : _property$listing$med.items) && ___EmotionJSX(EventBoundary, {
    name: "listing"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, {
    fullscreenOnOpen: mobile,
    items: props.items,
    initialIndex: props.initialIndex,
    onSlideChange: props.onSlideChange,
    onSlideClick: props.onSlideClick,
    onSlideLeft: props.onSlideLeft,
    onSlideRight: props.onSlideRight,
    onClose: props.onClose
  })), props.historyGalleryOpen && ___EmotionJSX(EventBoundary, {
    name: "history"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, _extends({}, props.historyGalleryProps, {
    fullscreenOnOpen: mobile,
    onSlideChange: props.onPropertyHistoryGalleryChange,
    onSlideLeft: props.onPropertyHistoryGalleryLeft,
    onSlideRight: props.onPropertyHistoryGalleryRight,
    onSlideClick: props.onPropertyHistoryGalleryClick
  }))), (mobile || tablet) && ___EmotionJSX("div", {
    css: sharedStyles.watchlistButton
  }, ___EmotionJSX(AllhomesWatchlistButton, {
    listingId: parseInt(property.listing.id, 10),
    onAddToWatchlist: props.onAddToWatchlist,
    popupAlignment: "right",
    inactiveColour: variables.colour.white,
    activeColour: variables.colour.brandYellow
  }))), ___EmotionJSX(Inner, null, tablet && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(InnerLeft, null, desktop && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(AllhomesListingSummaryGraphQL, {
    property: property,
    onAddToWatchlist: props.onAddToWatchlist,
    onResizeFinished: () => window.dispatchEvent(new Event('resize')),
    clientRenderedDescription: props.clientRenderedDescription
  }, ___EmotionJSX(NbnCardGraphQL, {
    property: property
  })), (property.listing.availableNow || property.listing.availableFrom) && ___EmotionJSX(Section, null, ___EmotionJSX(ListingAvailabilityGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(ShareDetailsGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(SharePreferencesGraphQL, {
    property: property
  })), (tablet || desktop) && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), ___EmotionJSX("div", {
    ref: sidebarBottomRef
  })), (tablet || desktop) && ___EmotionJSX(InnerRight, null, ___EmotionJSX(StickySidebox, {
    sidebarBottom: sidebarBottomRef
  }, ___EmotionJSX(OnMarketSidebox, _extends({}, props, {
    property: property,
    onEmailClick: handleEmailClick
  })))), ___EmotionJSX(Clear, null), !isEmpty(property.address.coordinates) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(Clear, null), ___EmotionJSX(AllhomesListingMapGraphQL, _extends({
    property: property,
    onTabSelect: props.onMapTypeSelect,
    onOverlaySelect: props.onMapOverlaySelect,
    onMapFirstInteraction: props.onMapFirstInteraction
  }, props))), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "mobile"
  })), !isEmpty(property.address.nearbyPOIs) && ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingWhatsNearbyGraphQL, {
    property: property,
    columns: desktop ? 3 : 2
  })), ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(PropertyHistoryGraphQL, {
    property: property,
    onPhotoClick: props.openHistoryGallery,
    onSwipeLeft: props.onPropertyHistorySwipeLeft,
    onSwipeRight: props.onPropertyHistorySwipeRight,
    onTapLeftChevron: props.onPropertyHistoryTapLeft,
    onTapRightChevron: props.onPropertyHistoryTapRight,
    onExpand: props.onPropertyHistoryExpand,
    onCollapse: props.onPropertyHistoryCollapse,
    isOnMarket: true
  })), ___EmotionJSX(Bottom, null, (tablet || desktop) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "tabbed"
  })), props.flagAsInappropriateLink && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(FlagAsInappropriateLink, {
    href: props.flagAsInappropriateLink
  }))))), ___EmotionJSX("div", {
    ref: enquiryFormStart
  }), ___EmotionJSX(ListingViewsGraphQL, {
    property: property
  }));
};
BaseOnMarketShareListingDetails.propTypes = _objectSpread(_objectSpread({}, ListingDetailsCommonProps), {}, {
  shareListingEmailLink: PropTypes.string,
  flagAsInappropriateLink: PropTypes.string
});
BaseOnMarketShareListingDetails.defaultProps = _objectSpread(_objectSpread({}, ListingDetailsDefaultValues), {}, {
  shareListingEmailLink: null,
  flagAsInappropriateLink: null
});
export default onMarketPropertyWrapper(withEventBoundary('share')(BaseOnMarketShareListingDetails));
export { BaseOnMarketShareListingDetails };